import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth as authApi } from '../api';
import { initCurrencySettings } from '../utils/format';
import { getCountryConfig } from '../utils/countries';

const AuthContext = createContext(null);

function applyBusinessLocale(business) {
  if (!business) return;
  const config = getCountryConfig(business.country || 'IN');
  initCurrencySettings(config.locale, config.currency, config.symbol);
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('bt_token'));
  const [user, setUser] = useState(null);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    authApi.me()
      .then((res) => {
        setUser(res.data.user);
        setBusiness(res.data.business);
        applyBusinessLocale(res.data.business);
      })
      .catch(() => {
        localStorage.removeItem('bt_token');
        setToken(null);
        setUser(null);
        setBusiness(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const login = (data) => {
    localStorage.setItem('bt_token', data.token);
    setToken(data.token);
    setUser(data.user);
    setBusiness(data.business);
    applyBusinessLocale(data.business);
  };

  const logout = () => {
    localStorage.removeItem('bt_token');
    setToken(null);
    setUser(null);
    setBusiness(null);
  };

  const value = {
    token,
    user,
    business,
    setBusiness,
    loading,
    isAuthenticated: !!token,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
